import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { has } from 'lodash';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { BrigadesService } from '../../brigades.service';
import { Enums } from '../../../../../../../configs/Enums';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-rename-brigade-modal',
  templateUrl: './rename-brigade-modal.component.html',
  styleUrls: ['./rename-brigade-modal.component.scss'],
  standalone: false,
})
export class RenameBrigadeModalComponent implements OnInit {
  public id;
  public brigadeName;
  public brigade;
  public renameBrigadeLoading;
  public errorMessage;

  constructor(
    private brigadesService: BrigadesService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {}

  public onRenameBrigade() {
    this.renameBrigadeLoading = true;
    this.brigadesService.renameBrigade(this.brigade.id, { brigade_name: this.brigadeName }).subscribe(
      (response) => {
        this.renameBrigadeLoading = false;
        // this.brigade.brigade_name = response['data'].brigade.brigade_name;
        this.brigade.brigade_name = this.brigadeName;
        this.activeModal.close();
      },
      (error) => {
        if (has(error, 'error.metadata.code') && error.error.metadata.code === 100022) {
          this.errorMessage = 'Бригада с таким названием уже существует';
        } else {
          this.errorMessage = Enums.errorCodes[Enums.errorCodesMaps['BACKEND_ERROR']];
        }

        this.renameBrigadeLoading = false;
      }
    );
  }
}
